import { Component, OnInit } from '@angular/core';
import { QCTimePerUserItem } from '../../model/user-qc-time.model';
import { ReportsService } from '../../service/reports.service';
import { MetricsDataService } from '../../service/metrics-data.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
    selector: 'cv-metrics-table',
    templateUrl: 'metrics-table.component.html',
    styleUrls: ['metrics-table.component.scss'],
})
export class MetricsTableComponent implements OnInit {

    public loading$ = this.metricsDataService.loading$;
    qcTimePerUserItemsSub: Subscription;
    private atComponentDestroy = new Subject();

    public qcTimePerUserItems: QCTimePerUserItem[] = [];

    constructor(private reportsService: ReportsService, private metricsDataService: MetricsDataService) {}

    ngOnInit(): void {
        this.qcTimePerUserItemsSub = this.metricsDataService.qcItems$.pipe(takeUntil(this.atComponentDestroy)).subscribe(items => {
            this.qcTimePerUserItems = items ?? [];
          });
    }

    ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

    /**
     * Triggers an export of the table data
     * @returns {Promise<void>}
     */
    public async exportToExcel(): Promise<void> {
        const { startDate, endDate } = this.metricsDataService.lastSelectedDateRange;
        if (startDate && endDate) {
            this.reportsService.getUserQCTimeItemsCSV(
                startDate,
                endDate,
            );
        }
    }

    /**
     * Gets average of the data table by user item key.
     * @param { keyof QCTimePerUserItem } key - The key value of the user item metrics.
     * @returns {number} the average of the passed key value.
     */
    public getAverage(key: keyof QCTimePerUserItem): number {
        const total = this.qcTimePerUserItems.reduce((sum, item) => {
            const value = item[key];
            return sum + (typeof value === 'number' ? value : 0);
        }, 0);

        return this.qcTimePerUserItems.length
            ? parseFloat((total / this.qcTimePerUserItems.length).toFixed(1))
            : 0;
    }
}
